import { connect } from 'react-redux';
import { show } from 'redux-modal';
import { formatCurrencyUSD } from '../utils/utility.js';
import PaymentSummary from '../components/views/loaded/PaymentSummary';

const mapStateToProps = (state) => {
	return {
		apr: Number(state.calculatorData.current.apr),
		downPayment: formatCurrencyUSD(
			Number(state.calculatorData.current.downPayment)
		),
		selectedAprTerm: Number(state.calculatorData.current.selectedAprTerm),
		monthlyPayment: formatCurrencyUSD(
			Number(state.calculatorData.current.monthlyPayment)
		)
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		showModal: (name, props) => {
			dispatch(show(name, props));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSummary);
